import { motion } from "framer-motion";

const capabilities = [
  {
    heading: "Drone Survey & Mapping Services",
    body: "As a professional drone survey company in India, we deliver drone land survey, drone topographic survey, cadastral and boundary surveys, contour mapping, terrain mapping and accurate area & volume calculations. Our UAV survey services support earthwork, stockpile, mine and quarry surveys with survey-grade GIS-compatible outputs.",
  },
  {
    heading: "Drone LiDAR Survey India",
    body: "Our LiDAR drone survey services generate high-density point clouds and Digital Terrain Models (DTM), Digital Surface Models (DSM) and Digital Elevation Models (DEM). With vegetation-penetration LiDAR we handle corridor, utility, railway, highway, forest and powerline LiDAR mapping.",
  },
  {
    heading: "Drone Photogrammetry & 3D Mapping",
    body: "UAV photogrammetry for orthomosaic mapping, 3D drone mapping, drone point clouds, 3D mesh models and BIM-ready digital twins — engineering-grade visualization for design, planning and asset management.",
  },
  {
    heading: "Construction Progress Monitoring",
    body: "Drone construction monitoring with weekly and monthly progress drone surveys, construction drone photography and videography, time-lapse documentation, infrastructure monitoring and detailed site progress reports for developers, consultants and contractors.",
  },
  {
    heading: "Drone Inspection Services",
    body: "Industrial drone inspection covering powerline inspection, transmission line and power tower inspection, thermal power inspection, substation and solar plant inspection, wind turbine, bridge, dam, chimney, roof, oil & gas, pipeline, tank, factory and warehouse inspection.",
  },
  {
    heading: "Railway, Road & Airport Survey",
    body: "Railway drone survey and railway construction monitoring, highway and expressway drone survey, NHAI drone survey, metro rail survey, bridge construction monitoring, airport drone survey, runway survey and airport construction progress photography.",
  },
  {
    heading: "Real Estate Drone Photography & Videography",
    body: "Real estate drone photography and videography, property drone shoots, township and luxury project drone videos, 4K aerial videography, FPV drone tours and construction marketing videos that convert.",
  },
  {
    heading: "360° Virtual Tours & GIS Mapping",
    body: "Interactive 360 virtual tours, drone 360 photography, floor-wise 360 views and virtual property tours, plus GIS mapping services, geospatial survey, geo-tagged survey and survey-grade spatial data collection.",
  },
];

const industries = [
  "Construction Drone Services",
  "Infrastructure Drone Services",
  "Mining Drone Survey",
  "Solar Farm Survey",
  "Wind Farm Inspection",
  "Smart City Survey",
  "Oil & Gas Survey",
  "Telecom Tower Inspection",
  "Port Survey",
  "Data Centre Construction Monitoring",
];

const locations = [
  "Drone Survey Mumbai",
  "Drone Survey Navi Mumbai",
  "Drone Survey Pune",
  "Drone Survey Thane",
  "Drone Survey Maharashtra",
  "Drone Survey Delhi",
  "Drone Survey Bangalore",
  "Drone Survey Hyderabad",
  "Drone Survey Chennai",
  "Drone Survey India",
];

export const SeoContent = () => {
  return (
    <section id="capabilities" className="py-24 bg-[#f8f9fa] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-widest text-[#8b8f99]">
            Capabilities
          </span>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-black text-[#10193f]">
            India&apos;s trusted drone survey &amp; inspection partner
          </h2>
          <p className="mt-4 text-[#52525b] leading-relaxed">
            Snesar Aerial Intelligence Pvt Ltd is a professional, safety-first
            drone survey provider delivering drone mapping services, aerial
            surveys and drone data collection for infrastructure, energy,
            construction and real estate clients across India.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
          {capabilities.map((c, i) => (
            <motion.article
              key={c.heading}
              data-testid={`capability-${i}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 2) * 0.06 }}
              className="border-l-2 border-[#10193f]/15 pl-5"
            >
              <h3 className="font-heading text-lg font-bold text-[#10193f]">
                {c.heading}
              </h3>
              <p className="mt-2 text-sm text-[#52525b] leading-relaxed">
                {c.body}
              </p>
            </motion.article>
          ))}
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-10">
          <div>
            <h3 className="font-heading text-xl font-bold text-[#10193f]">
              Industries We Serve
            </h3>
            <div className="mt-5 flex flex-wrap gap-2">
              {industries.map((t) => (
                <span
                  key={t}
                  className="rounded-sm border border-gray-200 bg-white px-3 py-1.5 text-sm text-[#10193f]/80"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
          <div>
            <h3 className="font-heading text-xl font-bold text-[#10193f]">
              Locations We Cover
            </h3>
            <div className="mt-5 flex flex-wrap gap-2">
              {locations.map((t) => (
                <span
                  key={t}
                  className="rounded-sm border border-gray-200 bg-white px-3 py-1.5 text-sm text-[#10193f]/80"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
